module.exports = __webpack_public_path__ + "img/right_orange_3_arrow_dark.83cf9bf7.svg";